import React, { useState } from 'react'


// filters
const filters = ['all',  'development', 'design', 'marketing', 'sales', 'finance']



export default function ProjectFilters({ currentFilter, changeFilter }) {
    // handle click
    const handleClick = (newFilter) => {
        changeFilter(newFilter)
    }

    return (
        <div className='project-filter'>
            <nav>
                <p>Filter by: </p>
                {filters.map((f) => (
                    <button 
                        key={f} 
                        className={currentFilter === f ? ' active' : ''} 
                        onClick={()=>handleClick(f)}>
                        {f}
                    </button>
                ))}
            </nav>
        </div>
    )
}
